import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class IconService {

  public logoUrl (brand: string): string {
    return this.getBrandLogoUrl(brand)
  }

  public logoSmallUrl (brand: string): string {
    return this.getBrandLogoUrl(brand)
  }

  private getBrandLogoUrl (brand: string): string {
    if (!brand) {
      return null
    }

    const cleanedBrand = brand.toLowerCase().split(' ').join('')
    return `https://cdn.insidehub.io/static/pp_brand_logo/${cleanedBrand}/logo/logo.png`
  }
}
